import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  alpha,
  Box,
  Divider,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { ModalHelp } from "../Modals/ModalHelp";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";

export const InvestigationSectionHeader = ({
  text = "",
  buttonText = "",
  buttonIcon,
  onClick = () => {},
  type = "",
  hideButton = false,
  extraButtons = [],
}) => {
  const theme = useTheme();
  const [t] = useTranslation("investigation");
  const [showModalHelp, setShowModalHelp] = useState(false);
  
  return (
    <>
      {/* <ModalHelp 
        show={showModalHelp}
        onHide={() => setShowModalHelp(false)}
        type={type}
      /> */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1}
        mb={1.5}
        boxShadow={`0px 4px 5px -2px ${alpha(
          theme.palette.oxfordBlue.main,
          0.25
        )}`}
        sx={{ backgroundColor: alpha(theme.palette.blueGray50.main, 0.3) }}
      >
        <Typography variant="h5">{text}</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {Array.isArray(extraButtons) &&
            extraButtons.length > 0 &&
            extraButtons.map((button, index) => (
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                key={index}
              >
                <Box>{button}</Box>
                <Divider sx={{ height: 28, m: 0.33 }} orientation="vertical" />
              </Stack>
            ))}
          {!hideButton && (
            <EGButton
              label={buttonText}
              iconName={buttonIcon}
              onClick={onClick}
            />
          )}
          {/* <Divider sx={{ height: 28, m: 0.33 }} orientation="vertical" />
          <EGIconButton
            iconName="outline_question_circle"
            iconColor="info"
            iconSize={21}
            onClick={() => setShowModalHelp(true)}
            title={t("investigation.about_this_section")}
            placement="left"
          /> */}
        </Stack>
      </Stack>
    </>
  );
};
